module.exports = __webpack_public_path__ + "img/public/SiteIcons/editStepFour.svg?6e6fb5b0";